import { render, staticRenderFns } from "./2024_newyear.vue?vue&type=template&id=3efefbbd&scoped=true&"
import script from "./2024_newyear.vue?vue&type=script&lang=js&"
export * from "./2024_newyear.vue?vue&type=script&lang=js&"
import style0 from "./2024_newyear.vue?vue&type=style&index=0&id=3efefbbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efefbbd",
  null
  
)

export default component.exports